interface ICopyIcon {
  className?: string;
  size?: number;
  fill?: string;
}

export const CopyIcon = ({ className, size, fill }: ICopyIcon) => {
  return (
    <svg
      className={className}
      width={size || '9'}
      height={size || '9'}
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H6V2H2V6H0V0ZM3 3H9V9H3V3Z"
        fill={fill || 'black'}
      />
    </svg>
  );
};
